// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_as-3";
export var contentContainer = "_as-0";
export var editorContainer = "_as-1";
export var quillInputForm = "_as-2";
export var zoneDivider = "_as-4";